import appRoutes from 'src/modules/app/routes'
import securityRoutes from 'src/modules/security/routes'
import oauthRoutes from 'src/modules/oauth/routes'
import profileRoutes from 'src/modules/profile/routes'

export default [
  appRoutes,
  securityRoutes,
  oauthRoutes,
  profileRoutes,
  {
    path: '/:catchAll(.*)*',
    redirect: '/'
  }
]
